import { renovationTimeline } from '@data/siteData';
import { Card, CardContent } from '@components/ui/Card';
import { Hammer, Heart } from 'lucide-react';

export default function RenovationPage() {
  return (
    <div className="py-12 bg-slate-950 min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-10">
          <h1 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Renovierung 2008 – 2015
          </h1>
          <p className="text-lg text-slate-400">
            Chronologie der Renovierungsarbeiten an der Alten Sternwarte von 2008 bis 2015.
          </p>
        </div>

        {/* Timeline */}
        <div className="space-y-6">
          {renovationTimeline.map((item, index) => (
            <Card key={index}>
              <CardContent className="flex gap-4 py-4">
                <div className="flex flex-col items-center">
                  <div className="w-12 h-12 bg-blue-600/10 rounded-full flex items-center justify-center shrink-0">
                    <Hammer className="text-blue-400" size={20} />
                  </div>
                  {index < renovationTimeline.length - 1 && (
                    <div className="w-0.5 flex-1 bg-slate-800 mt-2" />
                  )}
                </div>
                <div className="flex-1 pt-2">
                  <h3 className="text-xl font-bold text-blue-400 mb-2">{item.year}</h3>
                  <p className="text-slate-300">{item.event}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Thanks Section */}
        <div className="mt-12 bg-gradient-to-r from-green-900/20 to-blue-900/20 rounded-xl p-6 border border-green-800/30">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-green-600/10 rounded-lg flex items-center justify-center shrink-0">
              <Heart className="text-green-400" size={24} />
            </div>
            <div>
              <h2 className="text-xl font-bold text-white mb-2">Dank an alle Unterstützer</h2>
              <p className="text-slate-300">
                Die Renovierung wäre ohne die zahlreichen Spender, Förderer und ehrenamtlichen
                Helfer nicht möglich gewesen. Wir danken allen, die zum Erhalt dieses
                einzigartigen Kulturguts beigetragen haben.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
